import { render, staticRenderFns } from "./Cobranza.vue?vue&type=template&id=0ce9bd91&"
import script from "./Cobranza.vue?vue&type=script&lang=js&"
export * from "./Cobranza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports